
import { Injectable } from "@angular/core";
import { UseCase } from "../../base";
import { Observable } from 'rxjs';
import { PlanRequest } from "../../domain/requests/plans/plan.request";
import { AttachScheduler, AttachSchedulerRequest, Plan } from "../../domain";
import { PlansRepository } from "../../repositories";

@Injectable({ providedIn: 'root' })
export class GetSchedulerUsecase implements UseCase<string, AttachScheduler> {

  constructor(private readonly planRepository: PlansRepository) {
  }

  execute(params: string): Observable<AttachScheduler> {
    return this.planRepository.getScheduler(params);
  }

}